import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import PortfolioPage from "./pages/PortfolioPage";
import ProjectDetailsPage from "./pages/ProjectDetailsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import AdminPanel from "./pages/AdminPanel";
import { db } from "./config/firebase";
import { useDispatch } from "react-redux";
import { updateData, updatePortfolios } from "./features/dataSlice";

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const subscribe1 = db.collection("ashwin-info").onSnapshot((snapshot) => {
      snapshot.docs.map((doc) => {
        dispatch(updateData(doc.data()));
      });
    });
    const subscribe2 = db
      .collection("ashwin-projects")
      .onSnapshot((snapshot) => {
        const _portfolios = [];
        snapshot.forEach((doc) => {
          _portfolios.push({
            ...doc.data(),
            id: doc.id,
          });
        });
        dispatch(updatePortfolios(_portfolios));
      });
    return () => {
      subscribe1();
      subscribe2();
    };
  }, []);

  return (
    <div className="app">
      <Router>
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/projects" component={PortfolioPage} />
          <Route exact path="/projects/:id" component={ProjectDetailsPage} />
          <Route exact path="/about" component={AboutPage} />
          <Route exact path="/contact" component={ContactPage} />
          <Route exact path="/ash26" component={LoginPage} />
          <Route exact path="/admin26" component={AdminPanel} />
        </Switch>
      </Router>
    </div>
  );
};

export default App;
